import * as prefsActionTypes from 'js/constants/prefsAction-types';

const initialState = {
  prefLang: 'es',
  locale: 'es-MX',
};

function prefsReducer(state = initialState, action) {
  switch (action.type) {
    case prefsActionTypes.PREF_LANG_CHANGED:
      return {
        ...state,
        prefLang: action.lang.prefLang,
        locale: action.lang.locale,
      };
    default:
      return state;
  }
}

export default prefsReducer;
